import { Text } from '@cinch-labs/design-system'
import { Fragment } from 'react'

import { supportContactContent } from '../../data/content'
import styles from './support-address.module.css'

const SupportAddress = () => {
  const {
    addressHeading,
    address: {
      organisationName,
      buildingName,
      thoroughfare,
      postTown,
      postcode,
      country,
    },
    companyRegistrationInformation,
  } = supportContactContent

  const addressDetails = [
    organisationName,
    buildingName,
    thoroughfare,
    `${postTown} ${postcode} ${country}`,
    companyRegistrationInformation,
  ]

  return (
    <>
      <section className={styles.sectionContainer}>
        <div className={styles.textWrapper}>
          <Text
            element="h2"
            fontSize="xxl"
            fontWeight="bold"
            lineHeight="display"
          >
            {addressHeading}
          </Text>
        </div>

        <address>
          {addressDetails.map((addressDetail) => (
            <Fragment key={addressDetail}>
              <Text fontSize="xs" fontWeight="book">
                {addressDetail}
              </Text>
            </Fragment>
          ))}
        </address>
      </section>
    </>
  )
}

export default SupportAddress
